import React, { useState, useEffect } from 'react';
import {
  Edit,
  SimpleForm,
  TextInput,
  FileInput,
  ImageField,
  required,
  useUpdate,
  useNotify,
  useRedirect
} from 'react-admin';

import { uploadImage } from '../../../config/services/strapi/strapi';

function ImagenesInicioEdit(props: any) {
  const [imagesChanged, setImagesChanged] = useState({
    imagen: false,
  });

  const [update] = useUpdate();
  const redirect = useRedirect();
  const notify = useNotify();

  const handleSubmit = async (data: any) => {
    const token = localStorage.getItem('strapi_jwt');
    if (!token) {
      notify('No se encontró el token de autenticación', { type: 'error' });
      return;
    }

    try {
      const payload = JSON.parse(JSON.stringify(data));
      if (imagesChanged.imagen && data.imagen?.rawFile) {
        const imageResult = await uploadImage(data.imagen.rawFile, token);
        payload.imagen = imageResult;
      }

      delete payload.imagen.documentId;
      delete payload.id; // Asegurarse de no enviar el ID en el payload
      delete payload.createdAt;
      delete payload.updatedAt;
      delete payload.publishedAt;
      delete payload.documentId;
      delete payload.ref;

      await update('imagenes-inicios', { id: data.id, data: payload });
      notify('Imagen de inicio actualizada correctamente', { type: 'success' });
      redirect('list', 'imagenes-inicios');
    } catch (error) {
      console.error('Error actualizando imagen de inicio:', error);
      notify('Error al actualizar la imagen de inicio', { type: 'error' });
    }
  }

  useEffect(() => {
    document.title = 'Editar Imagen de Inicio';
  }, []);

  return (
    <Edit {...props}>
      <SimpleForm onSubmit={handleSubmit}>
        <TextInput source="nombre" validate={[required()]} />
        <TextInput source="texto_destacado" validate={[required()]} />
        <TextInput source="descripcion" validate={[required()]} />
        <FileInput
          source='imagen'
          label='Imagen'
          validate={[required()]}
          onChange={() => setImagesChanged({ ...imagesChanged, imagen: true })}
        >
          <>
            {imagesChanged.imagen && <ImageField source="src" title="title" />}
            {!imagesChanged.imagen && <ImageField source="url" title="title" />}
          </>
        </FileInput>
      </SimpleForm>
    </Edit>
  );
}

export default ImagenesInicioEdit